import _DTO from "./_DTO";
import SlottedAdditionalDeviceDTO from "./SlottedAdditionalDeviceDTO";
import DeviceAccessoryDTO from './DeviceAccessoryDTO';

export default class DeviceDTO extends _DTO {

  constructor(device) {
    super();
    this.id = device.id;
    this.slot = device.slot;
    this.slottedAdditionalDevices = DeviceDTO.getMappedOrDefault(device, 'slottedAdditionalDevices', [], data => data.map(d => new SlottedAdditionalDeviceDTO(d)));

    this.warranty = DeviceDTO.getOrDefault(device, 'warranty', null);
    this.accessories = DeviceDTO.getMappedOrDefault(device, 'accessories', [], data => (data || []).map(d => new DeviceAccessoryDTO(d)));
    this.auxiliaries = DeviceDTO.getMappedOrDefault(device, 'auxiliaries', [], data => (data || []).map(d => new DeviceAccessoryDTO(d)));
    this.sensors = DeviceDTO.getMappedOrDefault(device, 'sensors', [], data => (data || []).map(d => new DeviceAccessoryDTO(d)));
    this.spareParts = DeviceDTO.getMappedOrDefault(device, 'spareParts', [], data => (data || []).map(d => new DeviceAccessoryDTO(d)));
    this.options = DeviceDTO.getMappedOrDefault(device, 'options', [], data => (data || []).map(d => new DeviceAccessoryDTO(d)));


    this.customConsumptionLoads = DeviceDTO._extractCustomConsumptionLoads(device);
    this.customConsumptionDevices = DeviceDTO._extractCustomConsumptionDevices(device);
  }

  static _extractCustomConsumptionLoads(device) {
    return DeviceDTO.__extractCustomConsumption(device, 'Loads');
  }

  static _extractCustomConsumptionDevices(device) {
    return DeviceDTO.__extractCustomConsumption(device, 'Devices');
  }

  static __extractCustomConsumption(device, suffix) {
    const hasCustomConsumption = DeviceDTO.getMappedOrDefault(device, `hasCustomConsumption${suffix}`, false, v => Boolean(v));
    if (!hasCustomConsumption) {
      return null;
    }
    const consumption = DeviceDTO.getMappedOrDefault(device, `consumption${suffix}`, 0, v => parseFloat(v));
    const maxConsumption = DeviceDTO.getMappedOrDefault(device, `maxConsumption${suffix}`, 0, v => parseInt(v));
    if (consumption > maxConsumption || consumption < 0) {
      return null;
    }
    const customConsumption = DeviceDTO.getMappedOrDefault(device, `customConsumption${suffix}`, consumption, v => parseFloat(v));
    if (customConsumption >= maxConsumption || customConsumption < 0) {
      return null;
    }
    return customConsumption;
  }
}
